<div class="progression-matrix-donut-chart-body">
  <div class="progression-matrix-donut-chart-svg-wrapper">
    <svg viewBox="0 0 204 204" preserveAspectRatio="xMinYMin">
      <g transform="translate(102 102)">
        <!--    White background bar-->
        <circle class="progression-matrix-donut-chart-donut-empty" r="100"/>
        <!--    Energy-Green Bar with Value-->
        <circle class="progression-matrix-donut-chart-donut-filled" r="50"
                fill="transparent"
                stroke-width="100"
                [attr.stroke-dasharray]="'calc(' + value + ' * 314.2 / 100) 314.2'"
                transform="rotate(-90) translate(0)"/>
        <!--    Outer ring black line-->
        <circle class="progression-matrix-donut-chart-donut-rim" r="100"/>
        <!--    Donut Hole in the center-->
        <circle class="progression-matrix-donut-chart-donut-hole" r="55"/>
      </g>
    </svg>
    <div class="progression-matrix-donut-chart-center-text row"
         matTooltip="{{tooltip}}"
         style="font-size: {{textScale}}%;">
      {{label}}<br>{{value}}%
    </div>
  </div>

  <div class="progression-matrix-donut-chart-legend">
    <mat-icon *ngIf="icon" class="progression-matrix-donut-chart-legend-icon" svgIcon="{{icon}}" matTooltip="{{label}}"></mat-icon>
    <div class="progression-matrix-donut-chart-legend-box"></div>
    <span>Completed</span>
    <mat-icon class="progression-matrix-donut-chart-legend-tooltip" svgIcon="tooltip"
              matTooltip="The degree of ‘Completion’ shown here is calculated using the Completion status of all
              of the Development Phase milestones on the Schedule tab that fall within this Category. This may be
              a greater number of milestones than are shown here on the Development Stage Matrix tab."></mat-icon>
  </div>

</div>
